<template>
  <SheetContainer title="音标" desc="长按选中英文单词，设置音标发音">
    <div class="sheet-list">
      <div class="outer-phonetics">
        <van-field class="phonetics" v-model="phoneticsText" placeholder="例如：day的音标 [dei]" @focus="onCustomClick" />
        <div class="playAudio">
          <mo-listen-icon @listen="playAudio($event)" :listening="playStatus" :size="48"></mo-listen-icon>
        </div>
      </div>
      <div class="sheet-item remove" :class="{ removable }" @click="onRemoveClick">
        <span>移除</span>
      </div>
      <p class="danci">
        <span class="youdao" @click="copyUrl('youdaoUrl')">有道单词发音</span>
        <span @click="copyUrl('baiduUrl')">百度单词发音</span>
      </p>
    </div>
    <InputModal title="设置音标:" type="text" placeholder="例如：day的音标 [dei]" :visible.sync="customInputVisible" :allowNull="true"
      :defaultValue="phoneticsText" @confirm="onCustomInput" />
    <audio ref="phoneticsAudio" src=""></audio>
  </SheetContainer>
</template>
<script>
import { muteTimeList } from "@/views/index/config/muteList";
import { __getAudioUrl } from '@/utils/getAudio'
import InputModal from '@/components/input-modal/input-modal.vue'
import SheetContainer from '../sheet-container/sheet-container.vue'
import { copy } from '@/utils/util'
import $ from 'jquery'
import { toast } from '@/utils/util'
import { customCollectEvent } from '@/utils/collect';
export default {
  props: {
    value: {
      // 选中值信息
      type: String,
      default: ''
    },
    articleInfo: {
      // 选中值信息
      type: Object,
      default: () => {
        return {}
      }
    },
    isEffectUpdate: {
      // 选中值信息
      type: Boolean,
      default: false
    },
    selection: {
      // 选中信息
      type: Object,
      default: null
    }
  },
  components: {
    SheetContainer,
    InputModal
  },
  data() {
    return {
      muteObjs: muteTimeList.map((item,index) => {
        return {
          ...item,
          id: index + 1
        }
      }), // 预置的静音选项
      selectedValue: '', //当前选中的值，未选中或者清除时值为""
      customInputVisible: false, // 自定义弹窗是否显示
      phoneticsText: '',
      defaultValue: '',
      auditionAudio: null,
      playStatus: false,
      originText: "",
      BlobUrl: "",
    }
  },
  computed: {
    removable() {
      return this.selectedValue
    },
    customized() {
      return (
        this.selectedValue &&
        !this.muteObjs.some(mute => mute.value === this.selectedValue)
      )
    },
    customText() {
      return this.customized ? this.selectedValue : '+自定义'
    }

  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.phoneticsText = this.value
        this.selectedValue = this.value
        this.originText = this.getSelectedWord(this.selection)
      }
    },
    selection: {
      immediate: true,
      handler() {
        this.originText = this.getSelectedWord(this.selection)
      }
    }
  },
  mounted() {
    this.originText = this.getSelectedWord(this.selection)
    this.$refs.phoneticsAudio.addEventListener("ended",() => {
      this.revokeUrl()
    })
    this.$refs.phoneticsAudio.addEventListener("pause",() => {
      this.revokeUrl()
    })
  },
  methods: {
    // 删除音标
    onRemoveClick() {
      let phoneticsid = $(this.selection.el).attr("data-phoneticsid");
      let effectParam = {
        effectName: "phonetics",
        idName: "phoneticsid",
        id: phoneticsid,
        innerEffectName: "phoneticsInner",
      };
      this.phoneticsText = "";
      this.selectedValue = "";
      this.$emit("updateNode",effectParam,{},"delete");

    },
    revokeUrl() {
      this.playStatus = false
      this.$refs.phoneticsAudio.setAttribute("src",'')
      window.URL.revokeObjectURL(this.BlobUrl)
      this.BlobUrl = ""
    },
    checkEnglish(phonemeText){
      return new Promise((resolve,reject) => {
      let text=encodeURIComponent(`<speak><p phoneme="${phonemeText}">hello</p></speak>`) 
      let path=`/h5/english_cmu_check?text=${text}`
      fetch(path)
          .then(res=>res.json()).then((res )=>{
            resolve(res)
          }).catch((err)=>{
            reject(err)
          })
      })
    },
    createBlobUrl() {
      return new Promise((resolve,reject) => {
        if (!this.phoneticsText) {
          reject("请输入英文单词")
        }
        let text = this.originText
        const ssml =
          '<speak version="1.0" xml:lang="zh-CN" xmlns="http://www.w3.org/2001/10/synthesis" domain="public.weather">'
        const speak = '</speak>'
        let pron = this.phoneticsText.replace(/\[|]/g,'').trim()
        let p = `<p phoneme="${pron}">${text}</p>`
        let content = ssml + p + speak
        const txt = encodeURIComponent(content)
        let { audio_type,speed,articleId,ww_token } = this.articleInfo
        let speakerInfo = this.articleInfo.speaker
        let { speaker,source } = speakerInfo
        let pauseMap
        let wwid = localStorage.getItem("wwid")
        const requestUrl = __getAudioUrl({
          type: audio_type,
          speaker,
          speakerSource: source,
          speed,
          txt,
          articleId,
          pauseMap,
          wwid,
          ww_token
        }
        )

        fetch(requestUrl)
          .then(res=>res.blob()).then((res )=>{
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })

    },

    playAudio() {

      if (this.BlobUrl) {
        this.$refs.phoneticsAudio.setAttribute('src',this.BlobUrl)
        this.$nextTick(() => {
          this.playStatus = true
          this.$refs.phoneticsAudio.play()
        })
      } else {
        this.createBlobUrl().then((blob) => {
          this.BlobUrl = window.URL.createObjectURL(blob)
          this.$refs.phoneticsAudio.setAttribute('src',this.BlobUrl)
          this.$nextTick(() => {
            this.playStatus = true
            this.$refs.phoneticsAudio.play()
          })
        }).catch((err)=>{
          toast(err)
        })

      }

    },
    //复制url
    copyUrl(type) {

      let baiduUrl = `https://fanyi.baidu.com/#en/zh/${this.originText}`
      let googleUrl = `https://translate.google.cn/#view=home&op=translate&sl=en&tl=zh-CN&text=${this.originText}`
      let youdaoUrl = `http://www.youdao.com/w/eng/${this.originText}/`
      let Obj = {
        baiduUrl,
        googleUrl,
        youdaoUrl
      }
      copy(Obj[type]).then(() => {
        toast("链接已复制，请到浏览器粘贴链接查询音标")
      }).catch(() => {
        toast("链接复制失败")
      })
    },
    // 打开自定义弹窗
    onCustomClick() {
      this.customInputVisible = true

    },
    // 自定义输入
    onCustomInput(value) {
     
      this.customInputVisible=false
     
      if (value) {
        this.checkEnglish(value).then((res) => {
          if((res.cmu_check||res.cmu_check=='true')&&res.cmu_check!=='false'){
            this.phoneticsText = value
            this.updateValue(value)
          }else{
            toast("请输入正确的音标")
          }
         
        })
       
      }else{
        toast("请输入英文音标")
      }
    },
    // 校验选中是否合法

    isValid() {
      if (this.selection.el) {
        if ($(this.selection.el).attr('data-type') !== 'aliasChange') {
          toast('请选中10个字以内的文本')
          return false
        }
        return true
      }
      if (!this.selection.rangeText || !this.selection.rangeText.trim()) {
        toast('请选中10个字以内的文本')
        return false
      }

      if (this.selection.rangeText.length > 10) {
        toast('请选中10个字以内的文本')
        return false
      }
      let regExp = /^[A-Za-z]+$/
      if (!regExp.test(this.selection.rangeText)) {
        toast('请选择英文单词')
        return false
      }
      const $editor = this.$parent
    //   return false
    // // }
    //   if (
    //     $editor.hasEffectRange(this.selection.range,Object.values(effects),effects[])
    //   ) {
    //     toast('英文音标暂不支持与当前功能组合使用')
    //     return false
    //   }

      // 英文音标特效支持检查
      const speakerNotSupport = $editor.isRangeSpeakerNotSupportEffect(
        this.selection.range,
        'phonetics'
      )
      if (speakerNotSupport) {
        toast(`${speakerNotSupport.name.split('|')[0]}暂不支持英文音标`)
        return false
      }
      return true
    },
    // 更新静音值
    updateValue(newValue) {
      if (newValue !== this.selectedValue) {
        this.selectedValue = newValue
        if (!this.isEffectUpdate) {
          if (!this.isValid()) return
          this.$emit('update:value',newValue)
          this.$emit('change',newValue)
        } else {
          let phoneticsid = $(this.selection.el).attr('data-phoneticsid')
          let originpron = $(this.selection.el).attr('data-originpron')
          let effectParam = {
            effectName: 'phonetics',
            idName: 'phoneticsid',
            id: phoneticsid,
            innerEffectName: 'phoneticsInner'
          }
          this.$emit('updateNode',effectParam,{
            phoneticstext: newValue,
            originpron
          })
        }

        if (newValue) {
          customCollectEvent('editor_pron',{
            time: +newValue
          })
        }
      }
    },
    getSelectedWord(selection) {
      let wordText = "";
      if (selection.range && selection.rangeText) {
        // 滑动选中
        wordText = selection.rangeText;
      } else if (selection.el) {
        // 光标前
        wordText = selection.el.getAttribute("data-originpron");
      }
      return wordText.trim() // 排除空格
    }
  }
}
</script>
<style lang="less" scoped>
.outer-phonetics {
  width: 400px;
  position: relative;
  margin-right: 28px;

  .playAudio {
    display: inline-block;
    position: absolute;
    right: 10px;
    top: 10px;

  }

  .phonetics {
    border: 2px solid #cedcef;
    border-radius: 10px;
    padding: 0;
    padding-right: 10px;

    /deep/input {
      height: 62px;
      padding-left: 10px;
      font-size: 28px;
      padding-right: 50px;
    }

    /deep/.van-icon {
      font-size: 40px;
      color: #3583FB
    }
  }
}

.danci {
  position: absolute;
  bottom: 10px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3583FB;
  line-height: 40px;

  .youdao {
    margin-right: 40px;
  }
}
</style>
